export const ASPECT_RATIO_ATTRIBUTE = 'aspect-ratio';
export const CONTENT_POSITION_ATTRIBUTE = 'content-position';
export const WIDTH_ATTRIBUTE = 'width';
export const MEDIA_GROUP_ATTRIBUTE = 'media-group-id';

export const ASPECT_RATIO_CSS_PROPERTY = 'aspect-ratio';
export const WIDTH_CSS_PROPERTY = 'width';
export const CONTENT_POSITION_X_CSS_PROPERTY = '--ws-content-position-x';
export const CONTENT_POSITION_Y_CSS_PROPERTY = '--ws-content-position-y';
export const CONTENT_SCALE_CSS_PROPERTY = '--ws-content-scale';

export const MEDIA_CONTAINER_ANCHOR_HIGHLIGHT = 'ws-height-anchor-highlighter';
export const MEDIA_GROUP_ID_LENGTH = 6;
export const MIN_CONTAINER_HEIGHT = 16;
export const MAX_CONTAINER_HEIGHT = 4000;
export const MIN_CONTAINER_WIDTH = 16;
export const MAX_CONTAINER_WIDTH_PERCENTAGE = 100;
// Mirrors `--ws-media-container-max-width: 340px` from `.ws-m-logo-wrapper` in ws-templates.
export const MAX_BUSINESS_LOGO_WIDTH = 340;
